import { baseRequest } from '../../utils/HttpClient';
import { ApiEndpoints } from '../../constants/ApiEndpoints';

export const bypassProxy = payload => {
  return baseRequest(ApiEndpoints.BYPASS_PROXY, payload);
};
